import React, { type FunctionComponent } from 'react'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'
import { DashRoute } from 'legacy/dash-components/dash-route/DashRoute'
import { PerformanceMetrics } from 'legacy/sections/analytics/components/performance-metrics/PerformanceMetrics'

export const AnalyticsSection: FunctionComponent = () => {
  return (
    <DashSwitch>
      <DashRoute exact route="analytics-performance-metrics" component={PerformanceMetrics} />
    </DashSwitch>
  )
}
